import React from "react";

import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { ErrorMessage, RequiredMark } from "@components/inputs/shared";
import { LookupItem } from "@data-types";
import classNames from "classnames";

export default function PartnerRegistrationTitle(props: {
	titleData: LookupItem[] | null;
}) {
	const { titleData } = props;

	const { t } = useTranslation("registration");

	if (titleData == null || titleData.length === 0) {
		return null;
	}

	return (
		<div className="form__field">
			<label className="label label--strong">
				{t("TITLE_LABEL")}
				<RequiredMark required />
			</label>
			<ErrorMessage name="userTitleId" />

			<div className="row">
				{titleData
					?.reverse()
					.map((data) => (
						<RadioInput
							key={data.id}
							id={data.id}
							name="userTitleId"
							label={data.name}
							value={data.id}
							title={data.abrv}
						/>
					))}
			</div>
		</div>
	);
}

function RadioInput(props: {
	id: string;
	name: string;
	label: string;
	value: string;
	title: string;
}) {
	const { id, name, label, value, title } = props;

	const { t } = useTranslation();
	const { register } = useFormContext();

	const field = register(name, {
		required: {
			value: true,
			message: "COMMON.REQUIRED_FIELD",
		},
	});

	return (
		<div className="col col-sml-6">
			<div
				className={classNames(
					"input--radio input--title",
					`input--${title}`
				)}
			>
				<input
					id={id}
					className={classNames(
						"input--radio__box input--title__box",
						`input--${title}__box`
					)}
					type="radio"
					value={value}
					{...field}
				/>
				<label
					htmlFor={id}
					className={classNames(
						"input--radio__label input--title__label",
						`input--${title}__label`
					)}
				>
					{t(label)}
				</label>
			</div>
		</div>
	);
}
